<template>
    <div class="row">
        <div class="col-xl-12">
            <div id="panel-1" class="panel">
                <div class="panel-container show">
                    <div class="panel-content">
                        <el-row :gutter="10">
                            <div class="d-flex justify-content-end">
                                <el-button @click="exportExcel()" class="rounded" size="small" type="primary">Export<i class="el-icon-download el-icon-right ml-1"></i></el-button>
                            </div>
                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                                <el-input type="text" size="medium" v-model="form.name" class="mt-3"
                                          placeholder="Tìm tên hoặc SĐT học viên" autocomplete="false"></el-input>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                                <el-select v-if="[7,6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)" @change="getCenter()" v-model="form.area_id" placeholder="Chọn Khu vực" filterable  collapse-tags clearable class="w-100 mt-3">
                                    <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="[5,6,7].includes(keyAccount) || [295391, 266029].includes(currentUser.id) || currentUser.profile.account_type_id === 18">
                                <el-select @change="getChildUser(form.branch_id)" v-model="form.branch_id" placeholder="Chọn văn phòng" filterable clearable class="w-100 mt-3">
                                    <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                                <tree-select v-model="cache_sale" :normalizer=normalizer
                                             :options="options"
                                             :show-count="true" class="w-100 mt-3"
                                             placeholder="Chọn nhân sự muốn xem..."
                                             search-nested
                                             @input="handleChangeSale" >
                                    <!--eslint-disable-->
                                    <label slot="option-label"
                                           slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                                           :class="labelClassName">
                                        <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                                        <span> {{ node.label }} -  {{node.raw.id + 100000}}</span>
                                        <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                                    </label>
                                </tree-select>
                            </el-col>

                            <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                                <el-select v-model="form.account_type_id" placeholder="Chọn chức vụ" clearable class="w-100 mt-3">
                                    <el-option v-for="item in filteredPositions" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>

                            <el-col :xs="24" class="mt-3" :sm="12" :md="8" :lg="4" :xl="3">
                                <el-date-picker
                                    class="w-100"
                                    v-model="form.startDate"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    @change="pickStart"
                                    :picker-options="pickerStartOptions"
                                    placeholder="Từ ngày">
                                </el-date-picker>
                            </el-col>
                            <el-col :xs="24" class="mt-3" :sm="12" :md="8" :lg="4" :xl="3">
                                <el-date-picker
                                    class="w-100"
                                    v-model="form.endDate"
                                    type="date"
                                    ref="picker"
                                    :onPick="pickEnd"
                                    format="yyyy-MM-dd"
                                    @change="pickEnd"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerEndOptions"
                                    :disabled-date="disabledEndDate"
                                    placeholder="Đến ngày">
                                </el-date-picker>
                            </el-col>

                            <el-col v-if="isGDKV || isGDVP" :xs="24" :sm="12" :md="8" :lg="5" :xl="3">
                                <tree-select class="w-100 mt-3" @input="chooseSale"
                                             :show-count="true"
                                             search-nested v-model="form.sale"
                                             placeholder="Chọn nhân sự muốn xem..."
                                             :options="options"
                                             :normalizer=normalizer
                                >
                                    <!--eslint-disable-->
                                    <label slot="option-label"
                                           slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                                           :class="labelClassName">
                                        <img :src="getImageHierarchy(node.raw.profile.account_type.id)" alt=""> <span> {{
                                            node.label
                                        }} </span>
                                        <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                                    </label>
                                </tree-select>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8"
                                    :lg="isGDKV ? 4 : 5" :xl="3">
                                <el-select v-model="form.sale_type" class="w-100 mt-3" placeholder="Loại doanh số">
                                    <el-option
                                        v-for="item in sale_types"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                        <span style="float: left">{{ item.value }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="8"
                                    :lg="isGDKV ? 4 : 5" :xl="3">
                                <el-select v-model="form.type" clearable class="w-100 mt-3"
                                           placeholder="Phân loại nạp rút">
                                    <el-option
                                        v-for="item in types"
                                        :key="item.id"
                                        :label="item.label"
                                        :value="item.value">
                                        <span style="float: left">{{ item.label }}</span>
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="8" :lg="3" :xl="2">
                                <button :disabled="loading" class="btn btn-primary w-100 mt-3" @click="submit"><i
                                    v-bind:class="[loading ? 'el-icon-loading' : 'el-icon-search']"></i> Tìm kiếm
                                </button>
                            </el-col>
                        </el-row>
                        <div class="mb-5 mt-5">
                            <h4>Tổng doanh số {{ total_label }}: <b class="text-danger">{{
                                    totalSaleType | formatVND
                                }}</b></h4>
                        </div>

                        <el-table
                            :data="tableData"
                            stripe
                            v-loading="loading"
                            border
                            class="table-hover"
                            style="width: 100%">
                            <el-table-column label="#" type="index" width="50" :index="indexMethod">
                            </el-table-column>
                            <el-table-column
                                prop="id"
                                label="Mã hóa đơn"
                                width="100">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="Họ và tên"
                                width="160">
                            </el-table-column>
                            <el-table-column
                                prop="user_id"
                                label="Mã học viên"
                                width="110">
                            </el-table-column>
                            <el-table-column
                                prop="phone"
                                label="Điện thoại"
                                width="110">
                            </el-table-column>
                            <el-table-column label="Số tiền nộp" width="150">
                                <template v-slot="scope">
                                    <i class="el-icon-money"></i>
                                    <span style="margin-left: 10px" v-if="scope.row.amount_student">{{
                                            scope.row.amount_student |  formatVND
                                        }}</span>
                                    <span style="margin-left: 10px" v-else>0</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Phí trả góp" width="150">
                                <template v-slot="scope">
                                    <i class="el-icon-money"></i>
                                    <span style="margin-left: 10px" v-if="scope.row.is_installment == 1">{{
                                            -(scope.row.amount_student - scope.row.amount_installment) |  formatVND
                                        }}</span>
                                    <span style="margin-left: 10px" v-else>0đ</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Hệ số đội" width="90">
                                <template v-slot="scope">
                                    <span>{{ scope.row.business_coefficient }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Hệ số cá nhân" width="80">
                                <template v-slot="scope">
                                    <span>{{ scope.row.personal_coefficient }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Hệ số lên cấp" width="90">
                                <template v-slot="scope">
                                    <span>{{ scope.row.levelup_coefficient }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="checkCoefficient == 2"
                                             width="150"
                                             :label="checkCoefficient == 2 ? 'Doanh số cá nhân' : ''"
                            >
                                <template v-slot="scope">
                                    <i class="el-icon-money"></i>
                                    <!-- <span style="margin-left: 10px" v-if="checkCoefficient == 1 || !checkCoefficient">{{
                                            scope.row.amount_installment * scope.row.business_coefficient * (scope.row.type_sale == 1 && scope.row.is_branch_team == 1 && !form.capacity ? 2 : 1)|  formatVND
                                      }}</span> -->
                                    <span style="margin-left: 10px" v-if="checkCoefficient == 2">{{
                                            (scope.row.amount_installment * scope.row.personal_coefficient) * (scope.row.type_sale == 1 && scope.row.is_branch_team == 1 && !form.capacity ? 2 : 1) |  formatVND
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Doanh số lên cấp" width="150">
                                <template v-slot="scope">
                                    <i class="el-icon-money"></i>
                                    <span style="margin-left: 10px" class="text-break">{{
                                            scope.row.amount_installment * scope.row.levelup_coefficient | formatVND
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="form.sale_type == 3" label="Doanh số cá nhân" width="150">
                                <template v-slot="scope">
                                    <i class="el-icon-money"></i>
                                    <span style="margin-left: 10px" class="text-break">{{
                                            scope.row.amount_installment * scope.row.personal_coefficient | formatVND
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Loại doanh số" width="150" v-if="form.sale_type == 1">
                                <template v-slot="scope">
                                    <span style="margin-left: 10px  " class="text-break">{{
                                            scope.row.type_sale == 1 ? "Doanh số key" : "Doanh số Digital"
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-if="form.sale_type == 2" label="Doanh số đội" width="150">
                                <template v-slot="scope">
                                    <i class="el-icon-money"></i>
                                    <span style="margin-left: 10px" class="text-break">{{
                                            scope.row.amount_installment * scope.row.business_coefficient | formatVND
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Chi nhánh quyết toán" width="230">
                                <template v-slot="scope">
                                    <span style="margin-left: 10px" class="text-break">{{
                                            scope.row.branch_name
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Mã sales giới thiệu - sales" width="200">
                                <template v-slot="scope">
                                    <span style="margin-left: 10px" class="text-break">{{scope.row.sale_id + ' - '+ scope.row.sale_name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Mã TVV - TVV" width="200">
                                <template v-slot="scope">
                                    <span style="margin-left: 10px" class="text-break">{{scope.row.tvv_id + ' - '+ scope.row.tvv_name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Văn phòng sale" width="200">
                                <template v-slot="scope">
                                    <span style="margin-left: 10px" class="text-break">{{
                                            scope.row.branch_sale
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Văn phòng TVV" width="200">
                                <template v-slot="scope">
                                    <span style="margin-left: 10px" class="text-break">{{
                                            scope.row.branch_tvv
                                        }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Tư vấn viên" width="200">
                                <template v-slot="scope">
                                    <span style="margin-left: 10px" class="text-break">{{ scope.row.tvv_name }}</span>
                                </template>
                            </el-table-column>

                            <el-table-column
                                prop="dated_paid"
                                label="Ngày nộp"
                                width="100">
                            </el-table-column>
                            <el-table-column label="Ngày tạo" width="120">
                                <template v-slot="scope">
                                    <span style="margin-left: 10px">{{ scope.row.created_at | formatDate }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="Phân loại" width="110">
                                <template v-slot="scope">
                                    <el-button v-if="scope.row.type==='Nạp tiền'" size="mini" round type="success">Nạp
                                        tiền
                                    </el-button>
                                    <el-button v-if="scope.row.type==='Rút tiền'" size="mini" round type="danger">Rút
                                        tiền
                                    </el-button>
                                    <el-button v-if="scope.row.type==='Hoàn tiền'" size="mini" round type="warning">Hoàn
                                        tiền
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="edutalk-paging">
                            <div class="block">
                                <!--eslint-disable-->
                                <el-pagination
                                    background
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="paging.current_page"
                                    :page-size="Number(paging.per_page)"
                                    layout="prev, pager, next"
                                    :total="paging.total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {PAYMENT_LIST} from "@/core/services/store/payment.module";
import {BRANCH_LIST, HIERARCHY} from "@/core/services/store/service.module";
import {GDKV, GDVP, GDVPorGDKV, WATCH_AS_SALE, WATCH_AS_TP} from '@/core/config/accountTypeOption';

import lodash, {isBuffer} from 'lodash-es';
import deepdash from 'deepdash-es';
import {mapGetters} from "vuex";
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from "moment-timezone";
import {GET_USER_BY_ID} from "../../../core/services/store/profile.module";
import {GET_CHILD_USER} from "@/core/services/store/service.module";
import {GET_REGIONS_BY_USER} from "@/core/services/store/customer/customer.module";

const _ = deepdash(lodash);

export default {
    name: "EdutalkPayment",
    components: {},
    data() {
        return {
            moment: moment,
            pickerStartOptions: {
                disabledDate: this.disabledStartDate
            },
            pickerEndOptions: {
                disabledDate: this.disabledEndDate
            },
            paging: {
                current_page: 1,
                per_page: 10,
                total: 0,
            },
            dialogImageUrl: '',
            loading: false,
            currentPage: 1,
            selectDate: '',
            defaultValue: '',
            isGDKV: false,
            currentDate: new Date(),
            imageHierarchy: {
                '5': 'media/hierarchy/gdvp.png',
                '1': 'media/hierarchy/sl.png',
                '2': 'media/hierarchy/se.png',
                '3': 'media/hierarchy/s.png',
                '4': 'media/hierarchy/si.png'
            },
            total: {
                tong: 0,
                so_luot: 0,
                totalWithBusiness: 0
            },
            totalDigital: 0,
            totalTeam: 0,
            totalSaleType: 0,
            options: [],
            form: {
                name: '',
                startDate: null,
                endDate: null,
                view_as: '',
                branch_id: '',
                area_id: '',
                sale: null,
                type: '',
                account_type_id: '',
                sale_type: 1
            },
            cache_sale: null,
            branches: [],
            areas: [],
            watchAs: [
                {
                    id: 1,
                    value: 'Đội kinh doanh',
                    label: 'Đội'
                },
                {
                    id: 2,
                    value: 'Cá nhân',
                    label: 'Cá nhân'
                }
            ],
            sale_types: [
                {
                    id: 1,
                    value: 'Loại doanh số lên cấp',
                    total_label: 'lên cấp'
                },
                {
                    id: 2,
                    value: 'Loại doanh số đội',
                    total_label: 'đội'
                },
                {
                    id: 3,
                    value: 'Loại doanh số cá nhân',
                    total_label: 'cá nhân'
                }
            ],
            total_label: 'lên cấp',
            types: [
                {
                    id: 0,
                    value: '',
                    label: 'Tất cả'
                },
                {
                    id: 1,
                    value: 1,
                    label: 'Nạp tiền'
                },
                {
                    id: 2,
                    value: 2,
                    label: 'Rút tiền'
                },
                {
                    id: 3,
                    value: 3,
                    label: 'Hoàn tiền'
                }
            ],
            capacityDefine:
                [
                    {id: 2, name: 'Doanh số Digital'},
                    {id: 1, name: 'Doanh số key'}
                ],
            keyAccountMap: {
                7: [26, 6, 5, 1, 2, 3, 4], // BOD
                6: [6, 5, 1, 2, 3, 4, 26], // Giám đốc vùng
                5: [5, 1, 2, 3, 4, 6], // Giám đốc khu vực
                4: [1, 2, 3, 4, 5], // Giám đốc văn phòng
                3: [1,2, 3, 4], //Sales Leader
            },
            positions: [
                {id: 1, name: 'Sales Leader'},
                {id: 2, name: 'Sales Expert'},
                {id: 3, name: 'Sales'},
                {id: 4, name: 'Sales Intern'},
                {id: 5, name: 'Giám đốc văn phòng'},
                {id: 6, name: 'Giám đốc khu vực'},
                {id: 26, name: 'Giám đốc vùng'},
            ],
            tableData: [],
            show_field_sale_name: false,
            GDVPorGDKV,
            GDKV,
            GDVP,
            WATCH_AS_TP,
            WATCH_AS_SALE,
            startDate: '',
            checkCoefficient: 1,
            filter: true
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Danh sách"},
            {title: "Danh sách đóng tiền", icon: 'far fa-money-bill'}
        ]);
        let date = new Date();
        this.form.startDate = this.$moment().startOf('month').format('YYYY-MM-DD');
        this.form.endDate = this.$moment().format('YYYY-MM-DD');
        this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
        this.toDate = new Date();
        this.form.name = this.$route.query.search ?? '';
        // this.form.view_as = this.$route.query.view_as &&  this.$route.query.view_as == 'NaN' ? parseInt(this.$route.query.view_as) : '';
        if (this.currentUser.profile.account_type_id === this.GDKV || this.isGDVP) {
            this.watchAs.unshift({
                id: 0,
                value: 'TPhòng/Giám đốc',
                label: 'TP/GĐ'
            });
        }
        if (this.currentUser.profile.account_type_id === this.GDKV) {
            this.isGDKV = true;
        } else {
            // this.form.view_as = null;
            this.getChildUser();
            this.querySever();
        }

        // if (this.isGDVP) {
        //     this.handleChangeBranchGDVP(this.currentUser.profile.branch.id);
        // }
        this.getRegions();
        this.getCenter();
    },
    computed: {
        ...mapGetters(['currentUser', 'keyAccount']),

        isGDVP() {
            return this.currentUser.profile.account_type_id === this.GDVP
        },

        filteredPositions() {
            if (!this.keyAccount) return this.positions;
            const ids = this.keyAccountMap[this.keyAccount] || [];
            return this.positions.filter(p => ids.includes(p.id));
        }
    },
    methods: {
        getChildUser() {
            const payload = {
                branch_id: this.form.branch_id ?? '',
            };
            this.$store.dispatch(GET_CHILD_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.childUsers = response.data;
                        this.options = response.data;
                    }
                });
        },
        getImageHierarchy(account_type) {
            return this.imageHierarchy[account_type];
        },
        handleCurrentChange(val) {
            this.querySever({page: val});
        },
        indexMethod(index) {
            return 10 * (this.paging.current_page - 1) + (index + 1);
        },
        submit() {
            this.checkShowFieldName();
            this.querySever();
        },
        checkShowFieldName() {
            if (this.form.sale_type == 1 || this.form.sale_type == 2) {
                this.show_field_sale_name = true;
            } else {
                this.show_field_sale_name = false;
            }
        },
        handleChangeBranch() {
            if (this.form.branch_id > 0) {
                this.filter = true;
                this.$store.dispatch(HIERARCHY, {branch_id: this.form.branch_id})
                    .then((response) => {
                        this.form.sale = null;
                        this.options = response.data;
                    })
            } else {
                this.filter = false;
                this.form.sale = null;
                this.form.view_as = null;
                this.options = [];
            }
        },
        handleChangeBranchGDVP(branch_id) {
            this.filter = true;
            this.$store.dispatch(HIERARCHY, {branch_id: branch_id})
                .then((response) => {
                    this.form.sale = null;
                    this.options = response.data;
                })
        },
        exportExcel() {
            this.form.export = 1;
            const url = this.getExportUrl();
            window.open(url, '_blank');
            this.form.export = 0;
        },

        getExportUrl() {
            const queryString = Object
                .keys(this.form)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.form[key] ?? '')}`)
                .join('&');

            return `${process.env.VUE_APP_API_URL}/payment/list?${queryString}`;
        },
        getCenter() {
            const payload = {
                area_id: this.form.area_id
            };

            this.$store.dispatch(BRANCH_LIST,payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.branches = response.data;
                    }
                })

        },
        chooseSale(user_id) {
            if (user_id) {
                this.$store.dispatch(GET_USER_BY_ID, user_id).then((res) => {
                    if (res.data.profile.account_type_id !== this.GDVP) {
                        this.watchAs = this.WATCH_AS_SALE
                    } else {
                        this.watchAs = this.WATCH_AS_TP
                    }
                })
            }
            if (!this.form.sale) {
                this.form.view_as = null
            }
        },
        normalizer: function (node) {
            return {
                id: node.id,
                label: node.name,
            }
        },
        querySever(customProperties) {
            this.loading = true;
            this.total_label = this.sale_types.find(item => item.id === this.form.sale_type).total_label ?? '';
            let params = this.mergeParams(customProperties);
            this.$router.push({
                name: 'payment-list',
                query: params
            })
            this.currentPage = 1;
            this.$store.dispatch(PAYMENT_LIST, params)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.tableData = response.data;
                        this.total = response.total;
                        this.paging = {
                            total: response.pagination ? response.pagination.total : '',
                            count: response.pagination ? response.pagination.total : '',
                            per_page: response.pagination ? response.pagination.per_page : '',
                            current_page: response.pagination ? response.pagination.current_page : '',
                            last_page: response.pagination ? response.pagination.last_page : '',
                        }
                        this.totalTeam = response.total.tong ? response.total.tong : 0;
                        this.total = parseInt(this.totalDigital) + parseInt(this.totalTeam);
                        this.totalSaleType = parseInt(response.total.totalSaleType)
                        this.checkCoefficient = this.form.view_as;
                    }
                    this.loading = false;
                })
        },
        mergeParams(customProperties) {
            let params = {
                // page: this.paging.current_page,
                per_page: this.paging.per_page,
                // view_as: this.form.view_as,
                type: this.form.type,
                sale_type: this.form.sale_type
            };
            if (this.form.startDate) {
                params = _.merge(params, {startDate: this.form.startDate})
            }
            if (this.form.endDate) {
                params = _.merge(params, {endDate: this.form.endDate})
            }
            if (this.form.name) {
                params = _.merge(params, {search: this.form.name})
            }
            if (this.form.branch_id) {
                params = _.merge(params, {branch_id: this.form.branch_id})
            }
            if (this.form.sale) {
                params = _.merge(params, {sale: this.form.sale})
            }
            // if (this.form.view_as) {
            //   params = _.merge(params, {view_as: this.form.view_as})
            // }
            if (this.form.capacity == 1 || this.form.capacity == 2) {
                params = _.merge(params, {capacity: this.form.capacity})
            }
            if (this.form.area_id) {
                params = _.merge(params, {area_id: this.form.area_id})
            }
            if (this.form.account_type_id) {
                params = _.merge(params, {account_type_id: this.form.account_type_id})
            }
            if (this.form.sale) {
                params = _.merge(params, {sale: this.form.sale})
            }
            if (this.form.sale_type) {
                params = _.merge(params, {sale_type: this.form.sale_type})
            }
            params = _.merge(params, customProperties);
            return params;
        },
        /* date picker methods */
        pickStart(date) {
            this.fromDate = null;
            if (date) {
                this.fromDate = new Date(date);

            }
            this.checkEndDate(date);
        },
        pickEnd(date) {
            this.toDate = null;
            if (date) {
                this.toDate = new Date(date);
            }
        },
        disabledStartDate(date) {
            if (this.toDate) {
                return this.toDate < date
            }
            return date > new Date();
        },
        disabledEndDate(date) {
            if (this.fromDate) {
                let lastDate = moment(this.fromDate).endOf('month');
                return date > lastDate.toDate() || date <= this.fromDate;
            }
            return true;
        },
        checkEndDate(date) {
            let lastDate = moment(date).endOf('month');
            let valueEndDate = moment(this.form.endDate);
            if (!valueEndDate.isBetween(date, lastDate.toDate())) {
                this.form.endDate = moment(date).endOf('month').format('YYYY-MM-DD');
            }
        },
        getRegions() {
            const payload = {
                all: this.keyAccount === 7 ? 1 : 0
            };
            this.$store.dispatch(GET_REGIONS_BY_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.areas = response.data;
                    }
                })
        },

        handleChangeSale() {
            this.form.sale = this.cache_sale;
            if(!this.form.sale) {
                this.form.view_as = '';
            }
            this.queryServer();
        },

    },

}
</script>

<style>

</style>
